import KaraokeAnimationControls from './KaraokeAnimationControls';

export default KaraokeAnimationControls;
